import { ContentPagesLayoutConst } from '@core/content-layout/content-pages-layout/consts';

/**
 * Constants for the Units Management feature module.
 * Centralizes route paths, translation keys, and breadcrumb configuration.
 */
export abstract class UnitsManagementConst {

    /**
     * The display title for the Units Management module.
     */
    public static readonly TITLE = 'Units Management';

    /**
     * The root i18n translation key for the Units Management module.
     */
    public static readonly TRANSLATE_KEY = 'UNIT_MANAGEMENT';

    /**
     * The sidebar menu label translation key for the Units Management module.
     */
    public static readonly MENU_LABEL = [UnitsManagementConst.TRANSLATE_KEY, 'MENU_LABEL'].join('.');

    /**
     * The breadcrumb translation key for the Units Management root page.
     */
    public static readonly BREADCRUMB = [UnitsManagementConst.TRANSLATE_KEY, 'TITLE'].join('.');

    /**
     * The URL route segment for the Units Management module.
     */
    private static readonly _ROUTE_PREFIX = 'units-management';

    /**
     * The route page segment used in lazy-loaded route definitions.
     */
    public static readonly ROUTE_PAGE = UnitsManagementConst._ROUTE_PREFIX;

    /**
     * The full absolute route link for the Units Management module.
     */
    public static readonly ROUTE_LINK = `/${ContentPagesLayoutConst.ROUTE_PAGE}/${UnitsManagementConst.ROUTE_PAGE}`;

    /**
     * Child route and translation configurations for each sub-module.
     */
    public static readonly CHILDREN = {

        /**
         * Facility sub-module — single detail/view page.
         */
        FACILITY: {
            NAME: 'FACILITY',
            TITLE: 'Facility',
            ROUTE_PAGE: 'facility',
            TRANSLATE_KEY: () => {
                return [UnitsManagementConst.TRANSLATE_KEY, 'FACILITY'].join('.');
            },
            MENU_LABEL: function () {
                return [this.TRANSLATE_KEY(), 'MENU_LABEL'].join('.');
            },
            BREADCRUMB: function () {
                return [this.TRANSLATE_KEY(), 'TITLE'].join('.');
            },
            ROUTE_LINK: function () {
                return [UnitsManagementConst.ROUTE_LINK, this.ROUTE_PAGE].join('/');
            },
        },

        /**
         * Units sub-module — single detail/view page.
         */
        UNITS: {
            NAME: 'UNITS',
            TITLE: 'Units',
            ROUTE_PAGE: 'units',
            TRANSLATE_KEY: () => {
                return [UnitsManagementConst.TRANSLATE_KEY, 'UNITS'].join('.');
            },
            MENU_LABEL: function () {
                return [this.TRANSLATE_KEY(), 'MENU_LABEL'].join('.');
            },
            BREADCRUMB: function () {
                return [this.TRANSLATE_KEY(), 'TITLE'].join('.');
            },
            ROUTE_LINK: function () {
                return [UnitsManagementConst.ROUTE_LINK, this.ROUTE_PAGE].join('/');
            },
        },

        /**
         * Unit Types sub-module — list table page.
         */
        UNIT_TYPES: {
            NAME: 'UNIT_TYPES',
            TITLE: 'Unit Types',
            ROUTE_PAGE: 'unit-types',
            TRANSLATE_KEY: () => {
                return [UnitsManagementConst.TRANSLATE_KEY, 'UNIT_TYPES'].join('.');
            },
            MENU_LABEL: function () {
                return [this.TRANSLATE_KEY(), 'MENU_LABEL'].join('.');
            },
            BREADCRUMB: function () {
                return [this.TRANSLATE_KEY(), 'TITLE'].join('.');
            },
            ROUTE_LINK: function () {
                return [UnitsManagementConst.ROUTE_LINK, this.ROUTE_PAGE].join('/');
            },
        },

    };

}
